(function () {
  'use strict';

  angular.module('sempraWebapp').factory('ActivateAccountViewModel', activateAccountViewModelFactory);

  /** @ngInject */
  function activateAccountViewModelFactory () {
    function ActivateAccountViewModel () {
      this.password = '';
      this.repeatPassword = '';
      this.passwordIdentical = true;

      init.call(this);
    }

    return ActivateAccountViewModel;

    function init () {
    }
  }
})();
